import "./cookiebanner.scss"

// check if cookie concent decision was made and 'gtag_status='' exists
if (document.cookie.split(';').filter(function(item) {
  return item.trim().indexOf('gtag_status=') == 0
}).length) {
    // console.log('The cookie "gtag_status" exists')
} else {
  document.querySelector(".cookiebanner").classList.add('is-visible');
}